'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2017/7/15.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _components = require('components');

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopLogin = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('体验店登录')));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    loginValid: state.auth.loginValid,
    loginErrorMsg: state.auth.loginErrorMsg
  };
}, (0, _extends3.default)({}, authActions, { routerPush: _reactRouterRedux.push })), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopLogin, _Component);

  function ExperienceShopLogin() {
    (0, _classCallCheck3.default)(this, ExperienceShopLogin);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopLogin).call(this));
  }

  /*
   componentWillReceiveProps(nextProps) {
   const {user, dispatch} = this.props;
   if (!user && nextProps.user) {
   dispatch(push('/personalcenter/personalinfo'));
   }
   }*/

  (0, _createClass3.default)(ExperienceShopLogin, [{
    key: 'onLogin',
    value: function onLogin(data) {
      var _props = this.props;
      var login = _props.login;
      var routerPush = _props.routerPush;

      if (login) {
        login(data).then(function (nextData) {
          if (nextData.isValid !== false) {
            routerPush('/personalcenter/experienceshop/experienceshopinfo');
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var loginValid = _props2.loginValid;
      var loginErrorMsg = _props2.loginErrorMsg;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.ExperienceShopLoginComponent, { hideCloseModalBtn: true, onSubmit: this.onLogin.bind(this), loginValid: loginValid, loginErrorMsg: loginErrorMsg }),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ExperienceShopLogin;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  user: _react.PropTypes.object,
  login: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  loginValid: _react.PropTypes.bool,
  loginErrorMsg: _react.PropTypes.string
}, _temp)) || _class) || _class);
exports.default = ExperienceShopLogin;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopLogin/ExperienceShopLogin.js
 ** module id = 1471
 ** module chunks = 0
 **/